import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Collapse from '@mui/material/Collapse';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import CardActionArea from '@mui/material/CardActionArea';
import { useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useSettings } from '../context/SettingsContext';
import { useFlow } from '../context/FlowContext';
import { useI18N } from '../context/I18NContext';
import useWidgetStore from '../store/useWidgetStore';
import useDataStore from '../store/useDataStore';
import { useForm } from 'react-hook-form';
import { FormContainer } from 'react-hook-form-mui';
import { useNavigate, useParams } from 'react-router-dom';
import { useProducts } from '../hooks/query/useProducts';
import ConfigHolder from '../config/ConfigHolder';
import { isMobile } from '../../../helpers/browser';
import ObjectPicker from "../partials/pickers/ObjectPicker";
import ImageBackground from '../partials/ImageBackground';
export default function Category(props) {
    var _a, _b;
    const theme = useTheme();
    const params = useParams();
    const { t, ts } = useI18N();
    const productQuery = useProducts();
    const navigate = useNavigate();
    const flow = useFlow();
    const { orientation } = useSettings();
    const { enabled, setEnabled, cart, setCart } = useWidgetStore();
    const { products, categories, getProduct } = useDataStore();
    const [object, setObject] = useState();
    const [data, setData] = useState([]);
    const [addedProduct, setAddedProduct] = useState(false);
    const [addedProductName, setAddedProductName] = useState("Product");
    const [lines, setLines] = useState([]);
    useEffect(() => {
        if (!params.objectId) {
            navigate(`/oa_widget_shop`);
        }
    }, [params]);
    useEffect(() => {
        if (!enabled.category) {
            setEnabled(Object.assign(Object.assign({}, enabled), { category: true }));
        }
        if (!enabled.product) {
            setEnabled(Object.assign(Object.assign({}, enabled), { product: true }));
        }
    }, []);
    useEffect(() => {
        if (categories) {
            let category = categories.find((category) => { var _a; return category.id === parseInt((_a = params.objectId) !== null && _a !== void 0 ? _a : '0'); });
            if (category) {
                setObject(category);
                flow.title = t('Webshop');
            }
        }
    }, [flow === null || flow === void 0 ? void 0 : flow.currentRoute, categories, flow]);
    useEffect(() => {
        if (object) {
            if (typeof object.description === 'string' && object.description !== '') {
                let _lines = object.description.replaceAll("\n", "").split("<br />").filter((line) => line !== '');
                setLines(_lines);
            }
            // now the category is set, (re)fetch products 
            productQuery.refetch();
        }
    }, [object]);
    useEffect(() => {
        if (object && products) {
            // filter the products belonging to this category
            let _data = products.filter((product) => product.parentId === object.id);
            setData(_data);
        }
    }, [object, products]);
    useEffect(() => {
        if (object) {
        }
    }, [object, flow === null || flow === void 0 ? void 0 : flow.currentRoute]);
    const selectCallback = (productId, amount) => {
        var _a, _b;
        if (products) {
            let product = getProduct(productId);
            if (product) {
                let _lines = cart.lines, _lineItem = {
                    name: product.isVariation && product.variation
                        ? product.variation.name
                        : product.name,
                    price: product.isVariation && product.variation
                        ? product.variation.price
                        : product.price,
                    quantity: amount,
                    productId: productId,
                    productType: "product",
                    origin: "optionalPurchase"
                };
                // check if we already have this product, if so remove it ( so we can update quantity)
                _lines = _lines.filter((line) => line.productId !== productId);
                // add any required extra products
                if ((_a = product.crossselling) === null || _a === void 0 ? void 0 : _a.requires) {
                    (_b = product.crossselling) === null || _b === void 0 ? void 0 : _b.requires.forEach((requiredProductId) => {
                        let requiredProduct = products.find((_product) => {
                            if (_product.id === requiredProductId)
                                return _product;
                            return false;
                        });
                        if (requiredProduct) {
                            let _lineItem = {
                                name: requiredProduct.name,
                                price: requiredProduct.price,
                                quantity: 1,
                                productId: requiredProductId,
                                productType: "product",
                                origin: "requiredPurchase",
                                requiredBy: productId
                            };
                            _lines.push(_lineItem);
                        }
                    });
                }
                // add our new selection
                _lines.push(_lineItem);
                setCart(Object.assign(Object.assign({}, cart), { lines: _lines }));
                setAddedProductName(_lineItem.name);
                setAddedProduct(true);
            }
        }
    };
    const formContext = useForm({});
    const onSubmit = (data, event) => {
        // form does nothing, is just here to provide a context for the pickers inside
    };
    const onError = (errors) => { };
    const toNext = () => {
        if (orientation === "horizontal") {
            if (flow.onNext) {
                flow.onNext();
            }
        }
    };
    const toShop = () => {
        if (orientation === "horizontal") {
            setAddedProduct(false);
        }
        else {
            if (flow.onPrevious) {
                flow.onPrevious();
            }
        }
    };
    useEffect(() => {
        if (addedProduct) {
            setTimeout(() => {
                if (addedProduct) {
                    setAddedProduct(false);
                }
            }, 10000);
        }
    }, [addedProduct]);
    return (_jsxs(_Fragment, { children: [_jsx(Collapse, { in: addedProduct, children: _jsxs(Paper, { elevation: 4, sx: {
                        padding: 2,
                        margin: 1,
                        marginY: 4,
                        // position: 'sticky',
                        top: isMobile ? '32px' : '16px',
                        zIndex: 1,
                        position: 'fixed',
                        // top: "90px",
                        marginX: isMobile ? 2 : 1,
                        width: isMobile ? "calc(100% - 64px)" : "calc(100% - 110px)"
                    }, children: [_jsx(Alert, { severity: "success", sx: {
                                marginBottom: 2
                            }, action: _jsx(IconButton, { "aria-label": "close", color: "inherit", size: "small", onClick: () => {
                                    setAddedProduct(false);
                                }, children: _jsx(CloseIcon, { fontSize: "inherit" }) }), children: ts("%name% is toegevoegd aan je winkelwagen", { name: addedProductName }) }), _jsxs(Box, { sx: {
                                textAlign: "center"
                            }, children: [_jsx(Button, { variant: 'outlined', onClick: toShop, sx: Object.assign({ m: 1 }, isMobile && {
                                        width: '100%'
                                    }), children: t('Verder winkelen') }), _jsx(Button, { variant: 'contained', onClick: toNext, sx: Object.assign({ m: 1 }, isMobile && {
                                        width: '100%'
                                    }), children: t('Naar de winkelwagen') })] })] }) }), _jsx(FormContainer, { formContext: formContext, onSuccess: onSubmit, onError: onError, children: object && data && products && (_jsx(Box, { sx: { padding: isMobile ? 1 : 2 }, children: (object.image || object.description || object.name) && (_jsxs(Card, { elevation: 4, sx: { backgroundColor: theme.palette.background.default }, children: [orientation === 'horizontal' && !isMobile && (_jsxs(Box, { sx: { display: 'flex' }, children: [_jsx(Box, { sx: {
                                            position: 'relative',
                                        }, children: _jsx(ImageBackground, { noPositioning: true, pageHeader: true, name: object.name, imageUrl: `${ConfigHolder.apiBaseUrl}${object.image}?w=500&fit=scale` }) }), _jsx(Box, { sx: { display: 'flex', flexDirection: 'column' }, children: _jsxs(CardContent, { children: [object.name && (_jsx(Typography, { gutterBottom: true, sx: { color: theme.palette.text.primary, marginBottom: 1 }, variant: "h6", children: object.name })), object.subtitle && (_jsx(Typography, { sx: { color: theme.palette.text.primary, fontStyle: 'italic' }, variant: "subtitle2", children: object.subtitle })), lines.map((line, i) => {
                                                    return (_jsx(Typography, { variant: "body2", sx: { marginY: 2, color: theme.palette.text.secondary }, children: line }, i));
                                                })] }) })] })), orientation === 'vertical' || isMobile && (_jsxs(CardActionArea, { children: [_jsx(Box, { sx: {
                                            position: 'relative',
                                        }, children: _jsx(ImageBackground, { noPositioning: true, pageHeader: true, name: object.name, imageUrl: `${ConfigHolder.apiBaseUrl}${object.image}?w=500&fit=scale` }) }), _jsxs(CardContent, { children: [object.name && (_jsx(Typography, { gutterBottom: true, sx: { color: theme.palette.text.primary }, variant: "h5", children: object.name })), object.subtitle && (_jsx(Typography, { sx: { color: theme.palette.text.primary, fontStyle: 'italic' }, variant: "subtitle2", children: object.subtitle })), lines.map((line, i) => {
                                                return (_jsx(Typography, { variant: "body2", sx: { color: theme.palette.text.secondary, my: 1 }, children: line }, i));
                                            })] })] })), _jsx(Box, { children: _jsxs(Box, { sx: { paddingBottom: '64px', margin: orientation === 'vertical' || isMobile ? '0px 16px' : 2 }, children: [orientation === 'horizontal' && !isMobile && (_jsx(Divider, {})), _jsx(Typography, { gutterBottom: true, sx: {
                                                color: theme.palette.text.primary,
                                                marginLeft: 1,
                                                marginTop: orientation === 'vertical' || isMobile ? 1 : 2
                                            }, variant: "h6", children: t('Producten') }), _jsx(ObjectPicker, { source: "product", data: data, config: ((_b = (_a = flow.currentView) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.hasDetail) ? {
                                                toDetail: true,
                                                action: "detail",
                                                types: ["product", "giftcard", "membership", "subcscription"]
                                            } : {
                                                toDetail: false,
                                                action: "purchase",
                                                types: ["product", "giftcard", "membership", "subcscription"],
                                                selectCallback: selectCallback
                                            } })] }) })] })) })) })] }));
}
